export default __webpack_public_path__ + "static/media/github-icon.a9182f20.svg";